import {
  ID_VERIFIED_MODAL,
  KEY_AUTHENTICATED,
  NZTA_MAINTANENCE_MODE_MODAL,
} from '../constants';
import {platform} from '../../platform';

/**
 * Non-sensitive session flags.
 *
 * Reads are synchronous by contract — callers use them inside render and effect
 * conditionals. On web this is localStorage; on native it is an in-memory map
 * hydrated at boot that writes through to AsyncStorage. Never put credentials
 * here; those belong to `platform().auth`, which is async and secure-backed.
 */

export const getSessionItem = key => platform().storage.getItem(key);

export const setSessionItem = (key, value) =>
  platform().storage.setItem(key, value);

export const unSetSessionItem = key => platform().storage.removeItem(key);

export const getLoggedIn = () => getSessionItem(KEY_AUTHENTICATED) === 'true';

export const setLoggedIn = val =>
  setSessionItem(KEY_AUTHENTICATED, val || false);

export const unsetLoggedIn = () => unSetSessionItem(KEY_AUTHENTICATED);

export const setVerifiedUpgradeModalID = id =>
  setSessionItem(ID_VERIFIED_MODAL, id);

export const getVerifiedUpgradeModalID = () =>
  getSessionItem(ID_VERIFIED_MODAL);

export const getLastShownMaintanenceModal = () =>
  getSessionItem(NZTA_MAINTANENCE_MODE_MODAL);

export const setLastShownMaintanenceModal = date =>
  setSessionItem(NZTA_MAINTANENCE_MODE_MODAL, date);
